import { localizeDateTime, DateFormat } from 'utils/l10n/datetime';
import { useTranslation } from '../useTranslation';

export const useGetDisplayDate = (startDate: Date | null, endDate: Date | null) => {
  const { t } = useTranslation();
  const displayStartDate = startDate
    ? localizeDateTime(new Date(startDate), {
        dateStyle: DateFormat.Numeric,
      })
    : null;
  const displayEndDate = endDate
    ? localizeDateTime(new Date(endDate), {
        dateStyle: DateFormat.Numeric,
      })
    : null;

  if (startDate && endDate) {
    return t('insights.dateRange', {
      startDate: displayStartDate,
      endDate: displayEndDate,
    });
  }

  if (startDate) {
    return t('insights.afterDate', { startDate: displayStartDate });
  }

  if (endDate) {
    return t('insights.beforeDate', { endDate: displayEndDate });
  }

  return t('insights.allTime');
};
